import styled from "styled-components";
import {Link} from "react-router-dom";
import theme from "../styles/theme";

export const InlineLink = styled(Link)`
    position: relative;
    display: inline-block;
    color: ${theme.primaryBlue};
`;